import ApplyToJoin from "@/features/applications/apply";

const ApplyToJoinPage = () => {
  return <ApplyToJoin />;
};

export default ApplyToJoinPage;
